'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isExternalLink"];
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import useSettledUrl from '../../hooks/useSettledUrl';
import UsageTrackerPublic from '../../utils/UsageTrackerPublic';
import { getAchievementUrlSlug } from '../../utils/urls';
import { usePublicAchievement, useAchievementTrackId, useTrackPublicData, SingleAchievement } from '../../features/achievement';
import { useRouteMatch } from 'quartz-routing/react-router';
import { toAwardType } from '../../utils/awardTrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const PublicAchievementContainer = () => {
  const match = useRouteMatch('/achievements/:publicId/:language/:template/:slug+');
  const {
    language,
    publicId,
    slug
  } = match.params;
  const {
    publicAchievement,
    publicAchievementUser
  } = usePublicAchievement(publicId);
  const trackId = useAchievementTrackId(publicId);
  const {
    track: trackPublicData
  } = useTrackPublicData(trackId);
  const trackName = trackPublicData === null || trackPublicData === void 0 ? void 0 : trackPublicData.name;
  const urlSlug = publicAchievementUser && trackName ? getAchievementUrlSlug({
    firstName: publicAchievementUser.firstName,
    lastName: publicAchievementUser.lastName,
    trackName
  }) : undefined;
  useSettledUrl({
    actualSlug: slug,
    urlSlug
  });
  const type = toAwardType(publicAchievement === null || publicAchievement === void 0 ? void 0 : publicAchievement.credentialType);

  // TODO: Re-think tracking to avoid constantly prop drilling trackEvent
  const trackEvent = useCallback(_ref => {
    let extra = _objectWithoutPropertiesLoose(_ref, _excluded);
    if (!publicAchievement) return;
    UsageTrackerPublic.trackStandalone('Public Achievement Interaction', Object.assign({
      publicId,
      language,
      template: 'SINGLE_CERT',
      type
    }, extra));
  }, [language, publicId, type, publicAchievement]);
  return /*#__PURE__*/_jsx(SingleAchievement, {
    language: language,
    publicId: publicId,
    trackEvent: trackEvent
  });
};
PublicAchievementContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      publicId: PropTypes.string.isRequired,
      language: PropTypes.string.isRequired,
      actualSlug: PropTypes.string
    }).isRequired
  }).isRequired
};
export default PublicAchievementContainer;